import { useMutation } from "@tanstack/react-query"
import ReservationImport, { ReservationImportResult } from "~/api2/reservation_import"
import { useNotification } from "~/contexts/NotificationProvider"

interface Params {
  campId: string
  file: File
}

export const useReservationImport = () => {
  const { showNotification } = useNotification()

  return useMutation<ReservationImportResult, Error, Params>({
    mutationFn: ({ campId, file }) => ReservationImport.importCsv(campId, file),
    onSuccess: (data) => {
      showNotification({
        type: "success",
        title: "Import complete",
        description: `${data.created.length} rows imported, ${data.errors.length} failed`,
      })
    },
    onError: (err: any) => {
      showNotification({
        type: "error",
        title: "Error importing reservations",
        description: err.message,
      })
    },
  })
}

export type { ReservationImportResult }
